import { RouteObject } from "react-router";

export const InspectionRoutes: RouteObject[] = [
  {
    index: true,
    async loader(args) {
      const { inspectionIndexLoader } = await import("src/router/loaders/jobs/Inspection");
      return inspectionIndexLoader(args);
    },
    async lazy() {
      const { InspectionSelector } = await import("jobs/Job/InspectionsTab/InspectionSelector");
      return { element: <InspectionSelector /> };
    },
  },
  {
    path: ":inspectionId",
    async loader(args) {
      const { inspectionLoader } = await import("src/router/loaders/jobs/Inspection");
      return inspectionLoader(args);
    },
    shouldRevalidate({ currentParams, nextParams, defaultShouldRevalidate }) {
      // Don't revalidate when navigating within the same inspection (e.g. opening a modal via a
      // query/child route); only reload when switching to a different inspection.
      if (currentParams.inspectionId === nextParams.inspectionId) {
        return false;
      }
      return defaultShouldRevalidate;
    },
    async lazy() {
      const { InspectionEditor } = await import("jobs/Job/InspectionsTab/InspectionEditor");
      return { element: <InspectionEditor /> };
    },
    children: [
      {
        path: "attach/:lineItemId",
        async loader(args) {
          const { inspectionPhotoPickerLoader } = await import("src/router/loaders/jobs/Inspection");
          return inspectionPhotoPickerLoader(args);
        },
        shouldRevalidate({ currentUrl, nextUrl, defaultShouldRevalidate }) {
          // Re-list only when the picker's folder/page params change; not on unrelated editor nav.
          if (currentUrl.pathname === nextUrl.pathname && currentUrl.search === nextUrl.search) return false;
          return defaultShouldRevalidate;
        },
        async lazy() {
          const { JobPhotoPickerModal } = await import("jobs/Job/InspectionsTab/InspectionEditor/JobPhotoPickerModal");
          return { element: <JobPhotoPickerModal /> };
        },
      },
    ],
  },
];
